module.exports = __webpack_public_path__ + "img/logo.991faf16.svg";